import { Observable } from 'rxjs';

export class VisibaPopup {
	me: HTMLElement;
	buttonContainer: HTMLElement = null;
	extraButtonsContainer: Array<HTMLElement> = [];
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	myObserver: any;

	constructor(
		private title: string,
		private body: string,
		private className: string = '',
	) {
		this.baseHtml();
	}
	confirm(confirmBtn: string, cancelBtn: string, yesBtnExternalLink: string = null): VisibaPopup {
		this.createObserver();

		// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
		this.button('okRow', 'btn confirmBtn', confirmBtn, yesBtnExternalLink, () => {}, true);
		// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
		this.button('abortRow', 'abortBtn pointer', cancelBtn, null, () => {}, false, true);

		return this;
	}

	inform(buttonText: string): VisibaPopup {
		this.createObserver();

		// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
		this.button('okRow', 'btn', buttonText, null, () => {}, true);
		this.addCloseButton('x');
		return this;
	}

	link(buttonText: string, url: string, external: boolean = false): VisibaPopup {
		this.createObserver();

		this.addLink('', buttonText, url, external);
		return this;
	}

	persistant(): VisibaPopup {
		this.createObserver();
		return this;
	}

	/**
	 * Add extra button
	 */
	button(
		containerCls: string,
		cls: string,
		text: string,
		externalLink: string,
		callback: (instance: this, element: HTMLElement, redirect?: (success: boolean, link?: string) => void) => void,
		finishPromise: boolean | null = false,
		failPromise: boolean | null = false,
		useRedirect = false,
	): VisibaPopup {
		if (typeof this.extraButtonsContainer[containerCls] === 'undefined') {
			this.extraButtonsContainer[containerCls] = document.createElement('div');
			this.extraButtonsContainer[containerCls].className = 'extraButtons ' + containerCls;
			this.me.querySelector('.inner').appendChild(this.extraButtonsContainer[containerCls]);
		}

		let button = document.createElement('div');
		button.className = `${cls}`;
		if (externalLink === null) button.innerText = text;
		else button.innerHTML = '<a target="_blank" href="' + externalLink + '">' + text + '</a>';

		this.extraButtonsContainer[containerCls].appendChild(button);

		// Puts "__exposedFunction" in the HTMLElement instance so "removeEventListener" can be used later.

		if (failPromise !== null || finishPromise !== null) {
			const exposedFinishListner = () => {
				callback.call(this, this, button);

				if (finishPromise) this.myObserver.next({ el: this.me });
				else if (failPromise) this.myObserver.error({ el: this.me });

				if (finishPromise || failPromise) this.destroy();
			};

			button['__exposedFunction'] = exposedFinishListner.bind(this);

			button.addEventListener('click', button['__exposedFunction']);
		} else {
			const exposedCallbackListner = () => {
				// To prevent "block of popup" to happen after promises resolves, we must first open a new window inside this trusted event.
				// Then populate the new window's location to the desire location.
				// A regular window.open(LINK) will not work after the promise resolve - it will cause a "block of popup"
				let windowOpen;

				if (useRedirect) {
					windowOpen = window.open();
				}

				const redirect = (success: boolean, link: string) => {
					if (!useRedirect) return;

					if (success) {
						windowOpen.location.replace(link);
					} else {
						windowOpen.close();
					}
				};

				callback.call(this, this, button, redirect);
			};

			button['__exposedFunction'] = exposedCallbackListner.bind(this);

			button.addEventListener('click', button['__exposedFunction']);
		}

		return this;
	}

	loading(): VisibaPopup {
		let loadDiv = document.createElement('div');
		loadDiv.className = 'row loading';
		loadDiv.innerHTML = `<svg class="loader svg_Loader" viewBox="0 0 100 100 " style="transform: rotate(-90deg);">
                    <circle class="stroke" cx="50 " cy="50" r="40 " fill="none " stroke-width="6">
                        <animate attributeName="stroke-dasharray" dur="2s" repeatCount="indefinite" values="0 250; 250 50; 0 250; 0 250" keyTimes="0; 0.5; 0.9; 1"> </animate>
                        <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" values="0; 0; -40; -250; -250" keyTimes="0; 0.3; 0.5; 0.9; 1"> </animate>
                    </circle>
                </svg>`;

		this.me.querySelector('.inner').appendChild(loadDiv);

		return this;
	}

	disableButton(button: HTMLElement) {
		button.removeEventListener;
	}

	attatch(): VisibaPopup {
		document.querySelector('body').appendChild(this.me);

		return this;
	}

	element(): HTMLElement {
		return this.me;
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	observer(): Observable<any> {
		return this.myObserver;
	}

	destroy(): void {
		// Interface Node -> readonly isConnected: boolean;
		if (this.me && this.me['isConnected']) {
			this.me.parentElement.removeChild(this.me);
		}
		this.me = null;

		if (typeof this.myObserver !== 'undefined') {
			this.myObserver.complete();
		}
	}

	/** PRIVATE **/
	private createObserver() {
		this.myObserver = Observable.create((observer) => {
			this.myObserver = observer;
		});
	}

	private baseHtml() {
		this.me = document.createElement('div');
		this.me.className = `visibaPopupWrap ${this.className}`;
		this.me.innerHTML = `<div class="visibaPopup row">
                                <div class="inner span10"></div>
                            </div>`;

		if (this.title !== null && this.title !== '') {
			let title = document.createElement('h2');
			title.innerHTML = this.title;
			this.me.querySelector('.inner').appendChild(title);
		}

		if (this.body !== null && this.body !== '') {
			let title = document.createElement('div');
			title.className = 'text';
			title.innerHTML = this.body;
			this.me.querySelector('.inner').appendChild(title);
		}
	}

	private addLink(cls: string, text: string, url: string, external: boolean = false): HTMLElement {
		this.addButtonContainer();

		let btn = document.createElement('a');
		btn.className = `btn ${cls}`;
		btn.href = url;
		btn.target = external ? '_blank' : '';
		btn.innerText = text;
		this.buttonContainer.appendChild(btn);

		btn.addEventListener('click', () => {
			this.myObserver.next({ el: this.me });
			this.destroy();
		});

		return btn;
	}

	private addButtonContainer() {
		if (this.buttonContainer === null) {
			this.buttonContainer = document.createElement('div');
			this.buttonContainer.className = 'buttons';
			this.me.querySelector('.inner').appendChild(this.buttonContainer);
		}
	}

	private addCloseButton(text: string): HTMLElement {
		let btn = document.createElement('a');
		btn.className = 'close';
		btn.innerText = text;
		this.me.querySelector('.inner').appendChild(btn);

		btn.addEventListener('click', () => {
			this.myObserver.error({ el: this.me });
			this.destroy();
		});

		return btn;
	}
}
